import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';

export default {
  name: 'ConfigurationModalStepTwo',

  components: {
    ShButton,
    ShModalWindow,
  },

  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    domain: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {
        email: '',
      },
      installationType: '',
      rules: {
        email: { required: true, validator: this.emailValidator, trigger: 'blur' },
      },
      buttonText: 'Skopiuj kod',
    };
  },

  async created() {
    await this.getWidget();
  },

  computed: {
    widget() {
      return this.$store.getters['widgets/one'];
    },
    isCodeLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'widgets/getOne',
      ]);
    },
    isSendingMail() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'configurationFormSendMail/send',
      ]);
    },
    codeToSendInEmail() {
      if (this.installationType === 'wordpress') {
        return this.widget.key;
      }
      return this.widgetCode;
    },
    widgetCode() {
      // Nierówne ułożenie ze względu na białe znaki (inaczej by się źle wyświetlało)
      return `
  <script type="text/javascript">
    (function(d) {
        var s,c,o=function(){ 
          o._.push(arguments)
        };o._=[],q=new Date().getMilliseconds();
        s=d.getElementsByTagName('script')[0];c=d.createElement('script');
        c.type='text/javascript';c.charset='utf-8';c.async=true,
        c.src='//${process.env.VUE_APP_WIDGET_URL}/loader.js?q='+q;s.parentNode.insertBefore(c,s);
    })(document);

    var _callweb = _callweb || {
        key : '${this.widget.key}',
    };
  </script>
      `;
    },
  },

  methods: {
    getWidget() {
      try {
        this.$store.dispatch('widgets/getOne', this.widgetId);
      } catch (e) {
        console.log(e);
        // TODO: obsługa jeżeli podczas pobierania coś się nie uda
      }
    },
    onCopy() {
      this.buttonText = 'Skopiowano!';
    },
    handleSendMail() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          try {
            await this.$store.dispatch('configurationFormSendMail/send', {
              code: this.codeToSendInEmail,
              domain: this.domain,
              mail_to: this.form.email,
              mail_type: this.installationType,
            });
            this.form.email = '';
          } catch (error) {
            this.$message.error('Błąd wysyłki maila.');
            return;
          }
          this.$message.success('Email został wysłany poprawnie.');
        }
      });
    },
    emailValidator(rule, value, callback) {
      if (!this.form.email) {
        callback(new Error('Adres e-mail jest wymagany'));
      }
      // eslint-disable-next-line no-useless-escape
      if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(this.form.email)) {
        callback(new Error('Nieprawidłowy adres e-mail'));
      }
      callback();
    },
  },
};
